import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import { Observable, Subscription, tap } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { IExecuteSeccess, IMatchingColumn } from 'src/app/features/imports/models/imports.models';
import { ClearDetailsComparator, DetailsComparator, DetailsComparatorError, MatchingComparatorsColumns, MatchingComparatorsColumnsSuccess, SetComparatorLoader } from '../../store/comparator.actions';
import { ComparatorService } from '../../services/comparator.services';
import { FilterDetailsComparatorComponent } from '../filter-details-comparator/filter-details-comparator.component';
import { MatDialog } from '@angular/material/dialog';
import { generateExcel } from 'src/app/shared/utils/files-helpers';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-details-comparators',
  templateUrl: './details-comparators.component.html',
  styleUrls: ['./details-comparators.component.scss']
})
export class DetailsComparatorsComponent implements OnInit {

  comparatortId!: number;
  detailsComparator$: Observable<IExecuteSeccess | null> = this.store.select((state)=> state.comparators.detailsComparator);
  subscriptions: Subscription[] = [];
  comparatorFilter: any = {};
  products: any[] = [];
  filtredProducts: any[] = [];
  detailsComparator: IExecuteSeccess | null = null;
  isFilter: boolean = false;
  filterResult!: any
  baseUrl = environment.BASE_URL_API
  isObjectEmpty(obj: Record<string, string>): boolean {
    return Object.values(obj).every(value => value === "" || value === null || value === undefined);
  }
  
  
  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private services: ComparatorService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.comparatortId = +this.route.snapshot.paramMap.get('id')!;
    if (this.comparatortId) {
      this.store.dispatch(SetCurrentElementId({ currentElementId: this.comparatortId }))
      this.store.dispatch(DetailsComparator({ id: this.comparatortId }))
    }

    const sub1 = this.actions$.pipe(
      ofType(DetailsComparatorError),
      tap(() => {
        this.router.navigate(['comparators']);
      })
    ).subscribe();

    const sub2 = this.actions$.pipe(
      ofType(MatchingComparatorsColumnsSuccess),
      tap(() => {
        this.router.navigate(['comparators']);
      })
    ).subscribe();

    const sub3 = this.detailsComparator$.subscribe((data) => {
      if (data) {
        this.detailsComparator = data;
        this.products = data.preview.products;
        this.filtredProducts = this.products;
      }
    })

    this.subscriptions.push(sub1, sub2, sub3);
  }

  getBetterOffers(offers: any[], mainOffer: number): number{
    let betterOffers = 0;
    if(!offers || offers?.length === 0) return betterOffers;
    for (let i = 0; i < offers?.length; i++) {
      if (offers[i].price < mainOffer) {
        betterOffers++;
      }
    }
    return betterOffers;
  }

    // statistics
    getTotalBetterOffers(detailsComparator: IExecuteSeccess){
      let total = 0;
      detailsComparator.preview.products.forEach(product => {
        if(product['price'] - product['actual_price'] < 0){
          total++;
        }
      });
      return total;
    }
    getTotalOthersBetterOffers(detailsComparator: IExecuteSeccess){
      let total = 0;
      detailsComparator.preview.products.forEach(product => {
        total += this.getBetterOffers(product['other_imported_prices'], product['price']);
      });
      return total;
    }

  isLowestPrice(other_imported_prices: any[], item: any): boolean {
    if(!other_imported_prices || other_imported_prices?.length === 0) return true;
    
    return other_imported_prices.filter(product => product.id !== item.id).every((product: any) => product.price >= item.price);
  }
  commit(detailsImport: IExecuteSeccess) {
    const data: IMatchingColumn = {
      test: false,
      columns: detailsImport.matches.columns,
      fields: detailsImport.matches.fields.slice(0, detailsImport.matches.columns.length),
      sheet: detailsImport.preview.sheet,
      sheets: detailsImport.preview.sheets,
      name_create_enabled_fields: detailsImport.name_create_enabled_fields
    };
    this.store.dispatch(MatchingComparatorsColumns({ id: detailsImport.id, matchingColumns: data, committed: true }));
};

downloadFile(comparatorFile: any) {
  this.store.dispatch(SetComparatorLoader({ isLoading: true }));
  this.services.getFileComparator(comparatorFile.id).subscribe({
    next: (res: {data: [], object: {file: string}}) => {
      this.store.dispatch(SetComparatorLoader({ isLoading: false }));
      const byteCharacters = atob(res?.object?.file);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = comparatorFile.file_name;
      link.click();
    },
    error: (err) => {
      this.store.dispatch(SetComparatorLoader({ isLoading: false }));
    }
  });
}

async exportComparators() {
  if (!this.detailsComparator) {
    console.error('No data available for export.');
    return;
  }
  let products = (this.isFilter ? this.filtredProducts : this.detailsComparator.preview.products).map((product: any) => ({
    ...product,
    other_imported_prices: product.other_imported_prices.map((i: any) => i.price).join(', ')
  }));

  const currentDate = new Date().toISOString().replace('T', '_').split('.')[0]; 
  const filename = `comparators-data-${currentDate}.xlsx`;
  generateExcel(products, filename)
}

setFilter(key: string) {
  if (key === 'comparatorFilter') {
    const dialogRef = this.dialog.open(FilterDetailsComparatorComponent, {
      data: this.filterResult,
      minWidth: '650px',
      width: '80vw',
      height: '80vh',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.filterResult = result
          this.filtredProducts = this.products.filter((product: any) => {
            return (
              (!result.sku || product['sku']?.toLowerCase().includes(result.sku.toLowerCase())) &&
              (!result.name || product['name']?.toLowerCase().includes(result.name.toLowerCase())) &&
              (!result.imported_price_min || product['price'] >= result.imported_price_min) &&
              (!result.imported_price_max || product['price'] <= result.imported_price_max) &&
              (!result.inventory_price_min || product['actual_price'] >= result.inventory_price_min) &&
              (!result.inventory_price_max || product['actual_price'] <= result.inventory_price_max) &&
              (!result.other_prices_min || product['other_imported_prices'].length >= result.other_prices_min) &&
              (!result.other_prices_max || product['other_imported_prices'].length <= result.other_prices_max)
            )
          });
        this.isFilter = !this.isObjectEmpty(result);
      }
    });
  }
}

clearFilter() {
  this.isFilter = false;
  this.filtredProducts = this.products;
  this.filterResult = {}
}

hasModuleFilters(key: string): boolean {
  if (key === 'comparatorFilter') {
    return Object.keys(this.comparatorFilter).length > 0;
  } 
  return false;
}
  back(){
    this.router.navigate(['comparators'], {
      queryParamsHandling: 'merge',
    })
  }

  ngOnDestroy() {
    this.store.dispatch(ClearDetailsComparator())
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }
}
